import { Button } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  onSelectAll?: () => any;
  onSelectNone?: () => any;
  children: React.ReactNode;
}

export function SelectAllOrNone(p: Props) {
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ position: 'absolute', top: 0, right: 0 }}>
        {p.onSelectAll && (
          <Button
            variant="text"
            size="small"
            sx={{ padding: 0, minWidth: 0 }}
            onClick={p.onSelectAll}
          >
            <FormattedMessage id="common.actions.selectAll" defaultMessage="Seleccionar todos" />
          </Button>
        )}
        {p.onSelectNone && (
          <Button
            variant="text"
            size="small"
            sx={{ padding: 0, minWidth: 0, marginLeft: 1.5 }}
            onClick={p.onSelectNone}
          >
            <FormattedMessage id="common.actions.selectNone" defaultMessage="Seleccionar ninguno" />
          </Button>
        )}
      </div>
      {p.children}
    </div>
  );
}
